import {
	Backdrop,
	Box,
	Button,
	CircularProgress,
	Container,
	Stack,
	Typography,
} from "@mui/material";
import CustomField from "../forms/CustomField";
import { Form, Formik } from "formik";
import * as Yup from "yup";
import { IBlog } from "../../types/CommonTypes";
import CustomEditor from "../maintenance/CustomEditor";
import { calculateSlug, getRandomId } from "../../commons/constants/helpers";
import ImgPicker from "../img-picker/ImagePicker";
import { useEffect, useState } from "react";
import useBlog from "../../commons/hooks/useBlog";

const formScheme = Yup.object().shape({
	title: Yup.string().required("El título es requerido"),
	description: Yup.string().required("La descripción es requerida"),
	picture: Yup.mixed().required("La imagen de encabezado es requerida"),
	slug: Yup.string().notRequired(),
});

const initialState: Partial<IBlog> = {
	title: "",
	description: "",
	picture: null,
	isActive: null,
	summary: "",
	slug: "",
};

interface IProps {
	blogToEdit?: IBlog;
	onFinish: () => void;
}

const CreateBlog = ({ blogToEdit, onFinish }: IProps) => {
	const ID_REF = blogToEdit?.summary ?? getRandomId();
	const { handleCreateBlog, loading } = useBlog({
		resetBlog: () => onFinish(),
	});

	const handleSelectImage = (file: File, setFieldValue: any) => {
		if (file) {
			setFieldValue("picture", file);
		}
	};

	return (
		<Box sx={{ alignSelf: "center", p: 7, width: "70%" }}>
			<Formik
				initialValues={initialState}
				onSubmit={(values, { resetForm }) => {
					handleCreateBlog(values);
					resetForm();
				}}
				validationSchema={formScheme}
			>
				{({ values, errors, handleChange, setFieldValue }) => (
					<Form noValidate>
						<label>Imagen de encabezado</label>
						<ImgPicker
							selected={
								values.picture
									? URL.createObjectURL(values.picture)
									: ""
							}
							onSelect={(e) =>
								handleSelectImage(e, setFieldValue)
							}
							onDelete={() => setFieldValue("picture", undefined)}
							allowEdit
						/>
						<span className="error">
							{typeof errors.picture === "string"
								? errors.picture
								: ""}
						</span>

						<label>Título del blog *</label>
						<CustomField
							fullWidth
							label="Título"
							name="title"
							value={values.title || ""}
							onChange={handleChange}
							placeholder="Título del blog"
						/>
						<span className="error">{errors.title}</span>
						<label>Slug</label>
						<CustomField
							fullWidth
							label="Slug"
							name="slug"
							value={values.slug || ""}
							onChange={(e: any) => {
								setFieldValue(
									"slug",
									calculateSlug(e.target.value)
								);
							}}
							placeholder={calculateSlug(
								values.title || "slug-del-blog"
							)}
						/>
						<label>Descripción</label>
						<CustomEditor
							onChange={(html: string, textPlain?: string) => {
								setFieldValue("description", html);
								setFieldValue("summary", textPlain);
							}}
							idRef={ID_REF}
							initialText={blogToEdit?.description || undefined}
						/>
						<Stack
							direction={"row"}
							gap="10px"
							alignSelf={"flex-end"}
						>
							<Button
								variant="outlined"
								color="secondary"
								type="button"
								sx={{ mt: 2, alignSelf: "flex-end" }}
								onClick={() => onFinish()}
							>
								cancelar
							</Button>
							<Button
								variant="contained"
								color="primary"
								type="submit"
								sx={{ mt: 2, alignSelf: "flex-end" }}
							>
								Publicar
							</Button>
						</Stack>
					</Form>
				)}
			</Formik>
			<Backdrop
				open={loading}
				sx={{
					color: "#fff",
					zIndex: (theme) => theme.zIndex.drawer + 1,
				}}
			>
				<CircularProgress color="primary" />
			</Backdrop>
		</Box>
	);
};

export default CreateBlog;
